var angular = require('angular');

angular.module('satv.media')

/**
 * a medialist represents a list of tracks that are playable, draggable, selectable, downloadable
 * In order for certain functionality to work the following events are emitted that can be hooked into:
 *     - MEDIALIST_SELECT
 *     - MEDIALIST_STARTDRAG
 *     - PLAYLIST_ADD
 *     - MEDIA_PLAY
 */
    .directive('satvMediaList', ['$rootScope', 'AssetListCtrlDecorator', 'SelectHelper', 'Player', function ($rootScope, AssetListCtrlDecorator, SelectHelper, Player) {
        "use strict";

        return {

            restrict: 'A',

            link: function ($scope, element, attr, ctrl) {
                $scope.loader = $scope.$eval(attr.satvMediaList);
                $scope.paginateOnClick = attr.paginateOnClick === 'true';
                $scope.modelProperty = attr.modelProperty;
            },

            controller: function ($scope) {

                var that = this;

                /**
                 * Helper function to extract the real subject (track) based
                 * on whether modelProperty was set. ModelProperty can be set
                 * to point to a sub propert in the case when the track is a
                 * sub object of the array in the loader.data (e.g.)
                 * { ... track: {"name": "my track"}} instead of
                 * {"name": "my track"}
                 *
                 * @param  {[type]} subject [description]
                 * @return {[type]}         [description]
                 */
                function getRealSubject(subject) {
                    return $scope.modelProperty ?
                        subject[$scope.modelProperty] :
                        subject;
                }

                //decorate scope
                new AssetListCtrlDecorator($scope);

                //instantiate selection helper with subject loader
                //which will contain the data for subjects
                this.selectHelper = new SelectHelper($scope);

                //emit any changes in selections to parent scopes to provide a hook
                this.selectHelper.onSelect(function () {
                    $rootScope.$emit('MEDIALIST_SELECT', that.selectHelper.selected);
                });

                /**
                 * To register a child subjectlist
                 * @param  {Object} $childScope
                 */
                this.registerChild = function ($childScope) {
                    that.selectHelper.setNestedList($childScope);
                };

                /**
                 * @param  {Object} subject
                 * @param  {Object} $event
                 */
                $scope.handleClick = function (subject, $event) {
                    $event.stopPropagation();
                    that.selectHelper.handleClick(subject, $event);
                };

                /**
                 * @deprecated Use handleClick instead
                 * @param  {Object} subject
                 * @param  {Object} $event
                 */
                $scope.subjectClick = function (subject, $event) {
                    $scope.handleClick(subject, $event);
                };

                /**
                 * Shortcut
                 * @param  {Object}  subject
                 * @return {Boolean}
                 */
                $scope.isSelected = function (subject) {
                    return that.selectHelper.isSelected(subject);
                };

                /**
                 * Handler for dragging items
                 * @param  {Object} subject
                 */
                $scope.startDrag = function (subject) {
                    var subjectsToAdd;

                    //check if we're dragging one of the selected items, if so add all selected ones
                    if (that.selectHelper.isSelected(subject)) {
                        subjectsToAdd = that.selectHelper.getSelected();
                    } else {
                        subjectsToAdd = [subject];
                    }

                    $rootScope.$emit('MEDIALIST_STARTDRAG', subjectsToAdd);
                };

                /**
                 * Add a single subject to a playlist
                 * @param {Object} subject
                 */
                $scope.addToPlaylist = function (subject) {
                    $rootScope.$emit('PLAYLIST_ADD', [subject]);
                };

                /**
                 * @param  {Object} subject
                 */
                $scope.play = function (subject, $event, context, format) {
                    if ($event) {
                        $event.stopPropagation();
                    }
                    Player.play(false);
                    $rootScope.$emit(
                        'MEDIA_PLAY',
                        subject,
                        function () {
                            $scope.playNext(context, format);
                        },
                        context,
                        format
                    );
                };

                /**
                 * Play the next track in the list
                 */
                $scope.playNext = function (context, format) {
                    var current, next;

                    current = Player.getCurrent();

                    angular.forEach($scope.loader.data, function (subject, index) {
                        if (getRealSubject(subject).id === current.id) {
                            $scope.play(
                                getRealSubject($scope.loader.data[index + 1]),
                                null,
                                context,
                                format
                            );
                            return;
                        }
                    });
                };

                /**
                 * Whether a subject is playing.
                 * @param  {Object}  subject
                 * @return {Boolean}
                 */
                $scope.isPlaying = function (subject) {
                    var current = Player.getCurrent();
                    return current && current.id === subject.id;
                };

                /**
                 * Whether a track has been played before
                 *
                 * @param  {Object}  subject
                 * @return {Boolean}
                 */
                $scope.hasBeenPlayed = function (subject) {
                    return Player.getHistory().indexOf(subject.id) !== -1;
                };

                /**
                 * @param {Object} item
                 * @param {Object} $event
                 * @param {Object} context
                 */
                $scope.download = function (item, $event, context) {
                    $event.stopPropagation();
                    $rootScope.$emit('MEDIA_DOWNLOAD', [item], {}, context);
                };
            },

            replace: true,

            transclude: true,

            template: '<div ng-transclude><div>'

        };
    }])

    .directive('satvNestedMediaList', function (AssetListCtrlDecorator) {

        return {

            require: '^satvMediaList',

            link: function ($scope, element, attr, ctrl) {
                //decorate scope
                new AssetListCtrlDecorator($scope);

                //register the nested list with the parent
                ctrl.registerChild($scope);

                //nested lists must always have a click pager
                $scope.paginateOnClick = true;

                $scope.subjectClick = function (subject, $event) {
                    $event.stopPropagation();
                    ctrl.selectHelper.handleClick(subject, $event);
                };
            },

            replace: true,

            transclude: true,

            template: '<div ng-transclude></div>'
        };
    })

    //deals with selecting models in a list
    .factory('SelectHelper', function () {

        return function ($scope) {

            var $rootListScope, $nestedListScope;

            $rootListScope = $scope;

            /**
             * Helper to generate an sequential array of models including
             * any nested models
             * @param  {Object} toModel
             * @return {Array}
             */
            var getFlattenedListCollection = function (toModel) {
                var flattenedData = [],
                    models = $rootListScope.loader.data;

                //if model is a sub-property of the items in the loader,
                //get the actual models
                if ($scope.modelProperty) {
                    models = $rootListScope.loader.data.map(function (item) {
                        return item[$scope.modelProperty];
                    });
                }

                angular.forEach(models, function (model) {
                    flattenedData.push(model);

                    //get any visible nested models and append them into the flattened array
                    if ($nestedListScope && model === $nestedListScope.publication) {
                        var nestedModels = $nestedListScope.loader.data;

                        angular.forEach(nestedModels, function (nestedModel) {
                            flattenedData.push(nestedModel);
                        });
                    }
                });

                return flattenedData;
            };

            var onSelectCallbacks = [];

            return {

                /**
                 * An array of models
                 * @type {Array}
                 */
                selected: [],

                /**
                 * @param {Array}  loader
                 * @param {Object} ofPublication
                 */
                setNestedList: function ($scope) {
                    $nestedListScope = $scope;
                },

                /**
                 * Toggles a model as selected
                 * @param  {Object} model
                 */
                toggle: function (model) {
                    var index = this.selected.indexOf(model);

                    if (index === -1) {
                        this.setSelected(model);
                    } else {
                        this.selected.splice(index, 1);
                    }
                },

                /**
                 * Select a range of models (includes nested model)
                 * @param  {Object} toModel
                 * @return {Object}
                 */
                selectRange: function (toModel) {
                    var that, models, from, to;

                    that = this;
                    models = getFlattenedListCollection(toModel);
                    from = models.indexOf(this.selected[0]);
                    to = models.indexOf(toModel);

                    //swap from and to if necessary
                    if (to < from) {
                        to = [from, from = to][0];
                    }

                    //select the range
                    for (var i = from; i <= to; i++) {
                        this.setSelected(models[i]);
                    }
                },

                /**
                 * @param {object} model
                 */
                setSelected: function (model) {
                    if (this.selected.indexOf(model) === -1) {
                        this.selected.push(model);
                    }
                },

                /**
                 * On click handler for model
                 * @param  {Object} model
                 * @param  {Object} $event
                 */
                handleClick: function (model, $event) {

                    var that = this;

                    if ($event.shiftKey) {
                        this.selectRange(model);
                    } else if ($event.ctrlKey || $event.metaKey) {
                        this.toggle(model);
                    } else {
                        this.selected = [model];
                    }

                    //fire any registered callback functions
                    angular.forEach(onSelectCallbacks, function (callback) {
                        callback(that.selected);
                    });
                },

                /**
                 * @param  {Object}  model
                 * @return {Boolean}
                 */
                isSelected: function (model) {
                    return this.selected.indexOf(model) !== -1;
                },

                /**
                 * @return {Array}
                 */
                getSelected: function () {
                    return this.selected;
                },

                /**
                 * Register callback to fire when a selection occurs
                 * @param  {Function} callback
                 */
                onSelect: function (callback) {
                    onSelectCallbacks.push(callback);
                }
            };
        };
    });



// WEBPACK FOOTER //
// ./vendor/sonyatv/mediaclientbundle/Resources/js/angular/directives/medialist.js